// extracted by mini-css-extract-plugin
export var loadingShimmer = "_r6-2";
export var messageContent = "_r6-0";
export var messagesScroll = "_r6-1";
export var shimmer = "_r6-3";
export var shimmerW100 = "_r6-4";
export var shimmerW70 = "_r6-8";
export var shimmerW80 = "_r6-7";
export var shimmerW85 = "_r6-6";
export var shimmerW90 = "_r6-5";